import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { type UseMetricChartResult, useMetricChart } from '@/components/charts/generic';
import type { RespirationDataPoint } from '@/domain/behavior';
import { parseLocale } from '@/utils/localeFormatters';

import { buildRespirationSpec } from './respirationChartSpec';

interface UseRespirationChartDataParams {
    respirationDataPoints: RespirationDataPoint[];
}

/** The respiration page's chart: the breathing rate with swim speed for context. */
export function useRespirationChartData({
    respirationDataPoints,
}: UseRespirationChartDataParams): UseMetricChartResult<'line'> {
    const { t, i18n } = useTranslation('behaviorModule');
    const spec = useMemo(
        () =>
            buildRespirationSpec({
                points: respirationDataPoints,
                t,
                locale: parseLocale(i18n.language),
            }),
        [respirationDataPoints, t, i18n.language]
    );
    return useMetricChart(spec);
}
